/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

// @ts-ignore
function iNSConfigurationQuery(lineId?: string): DataServiceQuery {
    const key = lineId ? { LineId: lineId } : null;
    return new DataServiceQuery(
        'INSConfiguration',
        'INSConfigurationEntity',
        DataServiceEntities.INSConfigurationEntityExtensionClass,
        key
    );
}

export function createGetConfigurationInput(queryResultSettings: IQueryResultSettings, transactionId: string): IDataServiceRequest {
    const query = iNSConfigurationQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetConfiguration',
        false,
        DataServiceEntities.INSConfigurationEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IINSConfigurationEntity' },
        { transactionId: transactionId }
    );
}

export function getConfigurationAsync(
    context: IContext,
    transactionId: string
): AsyncResult<DataServiceEntities.IINSConfigurationEntity[]> {
    const request = createGetConfigurationInput(context.queryResultSettings || {}, transactionId);
    return callActionOrExecute<DataServiceEntities.IINSConfigurationEntity[]>(request, context.callerContext);
}

// @ts-ignore
function reCaptchaQuery(dataAreaId?: string): DataServiceQuery {
    const key = dataAreaId ? { DataAreaId: dataAreaId } : null;
    return new DataServiceQuery('ReCaptcha', 'CommerceParameterEntity', DataServiceEntities.CommerceParameterEntityExtensionClass, key);
}

export function createVerifyReCaptchaInput(captchaResponse: string): IDataServiceRequest {
    const query = reCaptchaQuery();
    return query.createDataServiceRequestForOperation(
        'VerifyReCaptcha',
        true,
        DataServiceEntities.VerifyCaptchaResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IVerifyCaptchaResponse' },
        { captchaResponse: captchaResponse }
    );
}

export function verifyReCaptchaAsync(context: IContext, captchaResponse: string): AsyncResult<DataServiceEntities.IVerifyCaptchaResponse> {
    const request = createVerifyReCaptchaInput(captchaResponse);
    return callActionOrExecute<DataServiceEntities.IVerifyCaptchaResponse>(request, context.callerContext);
}
